import { forwardRef } from 'react';

import { MtxIcon } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import styles from './SliderNavButton.module.css';

type SliderNavButtonProps = {
  direction: 'prev' | 'next';
};

const SliderNavButton = forwardRef<HTMLButtonElement, SliderNavButtonProps>(({ direction }, ref) => {
  const { t } = useTranslation();
  const isPrev = direction === 'prev';

  return (
    <button
      ref={ref}
      type="button"
      className={styles.navBtn}
      aria-label={isPrev ? t('slider.previous') : t('slider.next')}
    >
      <MtxIcon className={styles.iconArrow} name={isPrev ? 'arrow-left' : 'arrow-right'} size={28} />
    </button>
  );
});

SliderNavButton.displayName = 'SliderNavButton';

export default SliderNavButton;
